import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store.js';
import registerServiceWorker from './registerServiceWorker.js';
import './customize-button.js';

import App from './components/App.js';

ReactDOM.render(<Provider store={store}>
    <ConnectedRouter history={history}>
      <div>
        <App />
      </div>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'));

registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js